import { types } from './actions';

const initialState = {
  isDownloadingChargeReceipts: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.DOWNLOAD_CHARGE_RECEIPTS_REQUEST:
      return {
        ...state,
        isDownloadingChargeReceipts: true,
      };
    case types.DOWNLOAD_CHARGE_RECEIPTS_SUCCESS:
    case types.DOWNLOAD_CHARGE_RECEIPTS_ERROR:
      return {
        ...state,
        isDownloadingChargeReceipts: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.accounting.chargeReceipts;

export const isDownloadingChargeReceipts = (state) =>
  getScope(state).isDownloadingChargeReceipts;
